import { createBreakpoint } from 'react-use';
import { viewportSizes } from 'ui/utils';

export { default as useRoles } from './roles';
export { default as usePagination } from './pagination';

const breakpointHook = createBreakpoint(viewportSizes);

export const useBreakpoint = () => {
  const breakpoint = breakpointHook();

  return {
    breakpoint,
    isMobile: ['all', 'tabletMini'].indexOf(breakpoint) > -1,
  };
};
